import { Map } from 'immutable';
import { combineReducers } from 'redux-immutablejs';
import { INTERNAL_TAGS_PREFIX, TAGS_PREFIX } from 'app/models/tags/constants';
import { ADD_TAG_SUFFIX, FETCHED_TAGS_SUFFIX } from 'app/models/tags/actions';
import { InternalTag, Tag } from 'app/constants/schemas';
import { recordize } from 'app/remote/index';

const makeReducer = (TagType, actionPrefix) => (state = Map(), action) => {
  const { payload, type } = action;

  switch (type) {
    case `${actionPrefix}_${ADD_TAG_SUFFIX}`: {
      if (state.has(payload)) {
        return state;
      } else {
        return state.set(payload, new TagType({ name: payload }));
      }
    }

    case `${actionPrefix}_${FETCHED_TAGS_SUFFIX}`: {
      return state.merge(
        recordize(payload).map(tagRecord => [tagRecord.name, tagRecord]));
    }

    default:
      return state;
  }
};

export const tagsReducer = combineReducers({
  [INTERNAL_TAGS_PREFIX]: makeReducer(InternalTag, INTERNAL_TAGS_PREFIX),
  [TAGS_PREFIX]: makeReducer(Tag, TAGS_PREFIX),
});

export default tagsReducer;
